<template>
    <v-form ref="form">
        <v-row class="d-flex" align="center">
            <v-col cols="12" md="2">
                <v-select
                    v-model="traveler.prefix"
                    variant="outlined"
                    density="compact"
                    :items="['Mr', 'Ms', 'Mrs']"
                    :label="`${$t('salutation')}`"
                    hide-details
                    data-cy="prefix"
                />
            </v-col>
            <v-col cols="12" md="2">
                <v-text-field
                    v-model="traveler.firstName"
                    variant="outlined"
                    density="compact"
                    :label="`${$t('first_name')}`"
                    hide-details
                    data-cy="first-name"
                />
            </v-col>
            <v-col cols="12" md="2">
                <v-text-field
                    v-model="traveler.middleName"
                    variant="outlined"
                    density="compact"
                    :label="`${$t('middle_name')}`"
                    hide-details
                    data-cy="middle-name"
                />
            </v-col>
            <v-col cols="12" md="2">
                <v-text-field
                    v-model="traveler.lastName"
                    variant="outlined"
                    density="compact"
                    :label="`${$t('last_name')}`"
                    hide-details
                    data-cy="last-name"
                />
            </v-col>
        </v-row>
        <v-row class="d-flex" align="center">
            <v-col cols="12" md="2">
                <v-text-field
                    v-model="traveler.email"
                    variant="outlined"
                    type="email"
                    :rules="[emailRule('email')]"
                    density="compact"
                    :label="`${$t('email')}`"
                    hide-details
                    data-cy="email"
                />
            </v-col>
            <v-col cols="12" md="2">
                <phone-field
                    v-model="traveler.phone"
                    :label="$t('phone')"
                    hide-details
                    data-cy="traveler-field-phone"
                    density="compact"
                />
            </v-col>
            <v-col cols="12" md="2">
                <date-picker
                    v-model="traveler.dateOfBirth"
                    :label="$t('birthdate')"
                    :max="$dateFns.format(new Date())"
                    :rules="
                        (traveler.type === 'child' &&
                            (traveler.firstName || traveler.middleName || traveler.lastName)) ||
                        traveler.delete
                            ? [requiredRule('birthdate')]
                            : []
                    "
                    hide-details
                    density="compact"
                    outlined
                    dense
                    year-active-picker
                    data-cy="date"
                />
            </v-col>
            <v-col cols="12" md="2">
                <v-text-field
                    v-model="type"
                    variant="outlined"
                    density="compact"
                    disabled
                    :label="$t('flights.passenger_type')"
                    hide-details
                    data-cy="type"
                />
            </v-col>
            <v-col cols="12" :md="mealTypesList.length ? 2 : 1" class="d-flex" order="10" order-md="0">
                <v-select
                    v-if="mealTypesList.length"
                    v-model="traveler.alternativeMealTypeId"
                    :label="$t('meal_type')"
                    :items="mealTypesList"
                    item-title="name"
                    item-value="id"
                    variant="outlined"
                    density="compact"
                    hide-details
                    data-cy="meal-type"
                    @update:model-value="$emit('change-meal-type')"
                />
                <v-btn icon="mdi-close-box-outline" variant="text" @click="remove" />
            </v-col>
            <slot />
        </v-row>
    </v-form>
</template>

<script lang="ts">
    import {Component, Emit, mixins, Prop, VModel} from 'vue-facing-decorator'
    import DatePicker from '@/components/snippets/forms/DatePicker.vue'
    import {capitalizeTheFirstLetterOfEachWord} from '@/utils/helpers'
    import {FormValidationRulesMixin} from '@/mixins/FormValidationRulesMixin.vue'
    import PhoneField from '~/components/snippets/forms/PhoneField.vue'

    @Component({
        components: {PhoneField, DatePicker},
    })
    export class ModifyManualTraveler extends mixins(FormValidationRulesMixin) {
        @VModel({default: () => ({}), type: Object}) traveler
        @Prop({required: true}) index
        @Prop() mealTypesList

        @Emit()
        remove() {
            return this.index
        }

        get type() {
            return capitalizeTheFirstLetterOfEachWord(this.$t(this.traveler.type, 1))
        }

        set type(v) {}
    }

    export default ModifyManualTraveler
</script>
